export default Object.freeze({
  // ETC_NO_PERMISSION_
  TITLE: '권한 없음',
  BTN_MAIN: '메인으로'
});
